import React from "react";
import { Link } from "react-router-dom";
import { formatAED, resolveImg } from "../lib/api";

export default function PropertyCard({ property, index = 0 }) {
  return (
    <Link
      to={`/properties/${property.id}`}
      data-testid={`property-card-${property.reference}`}
      className="group block border border-zinc-200 bg-white hover:border-zinc-900 transition-colors"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-zinc-100">
        <img
          src={resolveImg(property.images?.[0]) || "https://images.unsplash.com/photo-1565891741441-64926e441838?w=800&q=80"}
          alt={property.title}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-0 left-0 flex flex-wrap">
          {property.rent_sale === "sale" && (
            <span data-testid="badge-for-sale" className="bg-[#FFCC00] text-[#031833] font-mono-tech text-[10px] px-2 py-1 uppercase">FOR SALE</span>
          )}
          {property.featured && (
            <span className="bg-[#031833] text-white font-mono-tech text-[10px] px-2 py-1 uppercase">★ Featured</span>
          )}
          <span className="bg-zinc-900 text-white font-mono-tech text-[10px] px-2 py-1 uppercase">
            {property.property_type.replace("_", " ")}
          </span>
        </div>
        <div className="absolute bottom-0 right-0 bg-white border-l border-t border-zinc-200 px-3 py-1.5">
          <span className="font-mono-tech text-[10px] text-zinc-500 uppercase">{property.reference}</span>
        </div>
      </div>

      <div className="p-5">
        <div className="flex items-baseline justify-between gap-3 mb-1">
          <span className="font-mono-tech text-[10px] uppercase text-zinc-500">{property.zone}</span>
          <span className="font-mono-tech text-[10px] uppercase text-zinc-500">
            {String(index + 1).padStart(3, "0")}
          </span>
        </div>
        <h3 className="font-display text-lg tracking-tighter leading-tight mb-3 line-clamp-2">
          {property.title}
        </h3>

        <div className="grid grid-cols-3 gap-2 mb-4 border-t border-zinc-100 pt-3">
          <div>
            <div className="font-mono-tech text-[9px] uppercase text-zinc-500">Size</div>
            <div className="font-mono-tech text-sm font-semibold">{formatAED(property.size_sqft)}<span className="text-[10px] text-zinc-500"> sqft</span></div>
          </div>
          <div>
            <div className="font-mono-tech text-[9px] uppercase text-zinc-500">Height</div>
            <div className="font-mono-tech text-sm font-semibold">
              {property.height_meters || "—"}<span className="text-[10px] text-zinc-500"> m</span>
            </div>
          </div>
          <div>
            <div className="font-mono-tech text-[9px] uppercase text-zinc-500">Bays</div>
            <div className="font-mono-tech text-sm font-semibold">{property.loading_bays || "—"}</div>
          </div>
        </div>

        <div className="flex items-end justify-between border-t border-zinc-100 pt-3">
          <div>
            <div className="font-mono-tech text-[9px] uppercase text-zinc-500">
              {property.rent_sale === "sale" ? "Sale Price" : "Annual Rent"}
            </div>
            <div className="font-display text-xl tracking-tighter">AED {formatAED(property.price_aed)}</div>
          </div>
          <div className="font-mono-tech text-[10px] uppercase text-[#031833] group-hover:translate-x-1 transition-transform">
            VIEW →
          </div>
        </div>
      </div>
    </Link>
  );
}
